export const heroData = {
  titleLine1: "Clear Beaches Start",
  titleLine2: "With You",
  subtitle: "Donate $14/month, get a free beach cleanup kit with your first donation, and fund kits for local volunteer groups cleaning coastlines every other month.",
  ctaText: "Start Donating",
  ctaLink: "/donate",
  secondaryCtaText: "How It Works",
  secondaryCtaLink: "/how-it-works",
};

export const howItWorksSteps = [
  {
    id: "step-1",
    icon: "ri-user-add-line",
    title: "Subscribe & Donate $14",
    description: "Sign up and set up your monthly $14 donation. Your first donation unlocks a free beach cleanup kit shipped right to your door.",
  },
  {
    id: "step-2",
    icon: "ri-gift-line",
    title: "Receive Your First Kit",
    description: "We ship your free beach cleanup kit — gloves, mesh collection bags, sand sifters, grabbers, and everything you need to lead a shoreline cleanup.",
  },
  {
    id: "step-3",
    icon: "ri-heart-line",
    title: "Keep Donating Monthly",
    description: "Every other month of continued donation, we send another cleanup kit to a volunteer group cleaning beaches in your local coastal community.",
  },
  {
    id: "step-4",
    icon: "ri-team-line",
    title: "Watch Beaches Transform",
    description: "Your ongoing support multiplies across coastlines, equipping more volunteers and creating cleaner, healthier beaches for everyone to enjoy.",
  },
];

export const impactStats = [
  { id: "stat-1", value: "8,200+", label: "Kits Donated" },
  { id: "stat-2", value: "2,100+", label: "Active Subscribers" },
  { id: "stat-3", value: "340+", label: "Beaches Served" },
  { id: "stat-4", value: "32,000+", label: "Volunteer Hours" },
];

export const testimonials = [
  {
    id: "testimonial-1",
    name: "Sarah Mitchell",
    role: "Subscriber since 2024",
    avatarSeq: "avatar-sarah",
    content: "I started donating because I was tired of seeing plastic wash up on my favorite beach. Getting that first kit made it real — I organized a cleanup that weekend and 20 people showed up. Now our beach looks completely different.",
  },
  {
    id: "testimonial-2",
    name: "Marcus Chen",
    role: "Coastal Volunteer Leader",
    avatarSeq: "avatar-marcus",
    content: "The kits we receive through clearbeaches.org have been game-changing for our monthly shoreline sweeps. Everything is built for sand and salt — the mesh bags drain water, the grabbers handle wet debris. Our volunteer numbers keep growing.",
  },
  {
    id: "testimonial-3",
    name: "Elena Rodriguez",
    role: "Subscriber since 2023",
    avatarSeq: "avatar-elena",
    content: "Fourteen dollars a month is less than two coffees, and the impact is visible. Knowing that every other month a kit goes to a group cleaning beaches in my own coastal community — that is what keeps me subscribed. Real change I can walk on.",
  },
  {
    id: "testimonial-4",
    name: "David Park",
    role: "Beach Cleanup Organizer",
    avatarSeq: "avatar-david",
    content: "Before clearbeaches.org, we were buying supplies out of pocket for every cleanup. Now we get fully stocked kits delivered on schedule. The sand sifters alone have saved us countless hours picking microplastics out of the shoreline.",
  },
  {
    id: "testimonial-5",
    name: "Jennifer Walsh",
    role: "Subscriber since 2024",
    avatarSeq: "avatar-jennifer",
    content: "I love that my donations stay local. I can walk down to the beach and see the difference. The transparency — knowing exactly where each kit goes — is what makes clearbeaches.org different from any other environmental charity I have donated to.",
  },
  {
    id: "testimonial-6",
    name: "Tom Briggs",
    role: "Marine Biology Educator",
    avatarSeq: "avatar-tom",
    content: "We use these kits for student field trips and coastal education days. Kids learn about ocean conservation while using real tools on real beaches. It turns classroom lessons into hands-on action. I have watched students become ocean advocates because of this program.",
  },
];

export const features = [
  {
    id: "feature-1",
    icon: "ri-anchor-line",
    title: "Local Coastline Impact",
    description: "Your donations fund kits that go directly to volunteer groups cleaning beaches in your own coastal community. See the difference you are making right on your shoreline.",
  },
  {
    id: "feature-2",
    icon: "ri-shield-check-line",
    title: "Full Transparency",
    description: "Track every kit from donation to beach deployment. We provide monthly reports showing exactly where your funded kits are being used along the coast.",
  },
  {
    id: "feature-3",
    icon: "ri-drop-line",
    title: "Beach-Ready Equipment",
    description: "Every kit includes mesh collection bags, sand sifters, waterproof gloves, grabbers, and safety supplies designed specifically for shoreline cleanup conditions.",
  },
];

export const aboutStats = [
  { id: "about-stat-1", value: "2023", label: "Founded" },
  { id: "about-stat-2", value: "30+", label: "Coastal Cities Active" },
  { id: "about-stat-3", value: "98%", label: "Subscriber Satisfaction" },
  { id: "about-stat-4", value: "0%", label: "Administrative Overhead" },
];